import React from 'react';
import { AppBar, Box, Toolbar } from '@mui/material';

import { NavBranding } from './NavBranding';
import { NavHelpMenu } from './NavHelpMenu';

export const PublicNav = () => {
  return (
    <AppBar
      position="sticky"
      color="primary"
      sx={{
        bgcolor: 'grey.100',
      }}
      elevation={1}
    >
      <Toolbar
        sx={{
          minHeight: 'inherit',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <NavBranding />
          <Box sx={{ marginLeft: 'auto' }}>
            <NavHelpMenu />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
